import { AbstractScreenValidationResult, ScreenValidationResult } from '../../../@types/validation-types'
import { camelCaseToDash } from '../../../utils/text/text-utils'

export const getInvalidFields = (
  validationResult: Record<string, ScreenValidationResult<AbstractScreenValidationResult>>,
  hasValidGeoCoordinates: boolean
) =>
  Object.entries(validationResult)
    .filter(([_, properties]) => properties.fields)
    .map(([_, properties]) => properties.fields!)
    .map((elem) =>
      Object.entries(elem)
        .filter(([_, results]) => results && results.length)
        .map(([property]) => property)
    )
    .flatMap((property) => property)
    .filter((property) =>
      ['manualCity', 'manualRegion', 'manualQuarter'].includes(property) ? !hasValidGeoCoordinates : true
    )
    .map(camelCaseToDash)
